import { writable } from 'svelte/store';
const browser = typeof window !== 'undefined'; // Use SvelteKit's browser check

function createPersistedStore(name, initialValue) {
  // Use the browser check from SvelteKit instead
  const storedValue = browser ? localStorage.getItem(name) : null;
  const initial = storedValue ? JSON.parse(storedValue) : initialValue;
  
  const store = writable(initial);
  
  // Subscribe to the store to persist changes to localStorage
  if (browser) {
    store.subscribe(value => {
      if (value !== undefined) {
        localStorage.setItem(name, JSON.stringify(value));
      }
    });
  }
  
  return store;
}

export const selectedStudy = createPersistedStore('selectedStudy', null);
export const selectedSite = createPersistedStore('selectedSite', null);
export const selectedParticipant = createPersistedStore('selectedParticipant', null);

// Enable these log statements for debugging
// selectedStudy.subscribe(value => console.log('selectedStudy updated:', value));
// selectedSite.subscribe(value => console.log('selectedSite updated:', value));
// selectedParticipant.subscribe(value => console.log('selectedParticipant updated:', value));
